export const configuration = {
  mcpAuth: {
    mcpClientId: process.env.MCP_CLIENT_ID,
    mcpClientSecret: process.env.MCP_CLIENT_SECRET,
  },
  serviceUrls: {
    msx: 'https://merchandising-site-experience.prod.merch.vpsvc.com/api',
    mcs: 'https://mcs-cdn.prod.content-platform.vpsvc.com/api',
    merchantProductOrchestration: 'https://merchant-orchestration-api.products.cimpress.io/v3/',
    mailingServicesContentUnifier: 'https://mailing-services-content-unifier.prod.ams.vpsvc.com/',
    accessoryProducts: 'https://accessory.products.cimpress.io',
    scenesRetriever: 'https://scenes-retriever.product-page-layouts.vpsvc.com',
    renderingDocuments: 'https://rendering.documents.cimpress.io/v1',
  },
  requestor: 'conan-pdp-flyouts-fragment',
  // TODO: Review this whenever multi-tenancy is implemented.
  redis: {
    host: process.env.REDIS_HOST!,
    port: parseInt(process.env.REDIS_PORT!),
  },
};
